// @ts-nocheck
/* eslint-disable */
import Content from './content';
import Weather from "~/weather";

export default class WeatherContent extends Content {
	destroy() {
		super.destroy();
		this._weather.destroy();
		this._weather = null;
	}

	getState() {
		return this._weather ? this._weather.state : {};
	}

	_build() {
		this._dom.container.classList.add("content-weather");
		this._weather = new Weather(this._data, this._dom.container);
	}
}
